import { render, staticRenderFns } from "./index.vue?vue&type=template&id=57fbd884&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../claims/index.less?vue&type=style&index=0&id=57fbd884&lang=less&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&id=57fbd884&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fbd884",
  null
  
)

export default component.exports